import { Skeleton, Stack } from '@mui/material'

const VerifyOrderPdfSkeletons = () => {
  return (
    <Stack spacing={2}>
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
      <Skeleton variant="rectangular" width="100%" height={200} />
      <Skeleton variant="rectangular" width="100%" height={100} />
      <Skeleton variant="rectangular" width="100%" height={200} />
      <Skeleton variant="rectangular" width="100%" height={200} />
    </Stack>
  )
}

export default VerifyOrderPdfSkeletons
